import React from 'react';
import cx from 'classnames';

import { DashIcon, PlusIcon } from '@motorway/mw-highway-code';

import { MAX_ZOOM_LEVEL, MIN_ZOOM_LEVEL } from '../../SwitchableMap.consts';

import styles from './MapZoomControl.module.scss';

export interface MapZoomControlProps {
	onZoomIn: () => void;
	onZoomOut: () => void;
	zoomLevel: number;
}

const MapZoomControl: React.FC<MapZoomControlProps> = ({ onZoomIn, onZoomOut, zoomLevel }) => {
	return (
		<div className={styles.controlContainerZoom}>
			<div className={styles.zoomControls}>
				<div className={styles.iconWrapper}>
					<button
						aria-label="Zoom in"
						className={cx([styles.icon, styles.zoomIn])}
						disabled={zoomLevel === MAX_ZOOM_LEVEL}
						onClick={onZoomIn}
						tabIndex={0}
					>
						<PlusIcon />
					</button>
					<div className={styles.divider}></div>
					<button
						aria-label="Zoom out"
						className={cx([styles.icon, styles.zoomOut])}
						disabled={zoomLevel === MIN_ZOOM_LEVEL}
						onClick={onZoomOut}
						tabIndex={0}
					>
						<DashIcon />
					</button>
				</div>
			</div>
		</div>
	);
};

export default MapZoomControl;
